/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import Media from 'react-media';

import Imgix from 'js/components/Imgix';

import type { StaticComponentProps } from 'bundles/coursera-plus-landing-page/components/heroContentful/Hero';
import type { DesktopImageProps } from 'bundles/coursera-plus-landing-page/components/heroContentful/LegacyDesktop';
import LegacyDesktop from 'bundles/coursera-plus-landing-page/components/heroContentful/LegacyDesktop';
import LegacyMobile from 'bundles/coursera-plus-landing-page/components/heroContentful/LegacyMobile';
import type { YellowDotsImage } from 'bundles/coursera-plus-landing-page/components/heroContentful/design/constants';
import {
  YELLOW_DOTS_IMAGE_SIZES,
  mobileBreakpoint,
  xlImageBreakpoint,
} from 'bundles/coursera-plus-landing-page/components/heroContentful/design/constants';

import dots from 'images/coursera-plus/dots.png';
import headerImageMobile from 'images/coursera-plus/header-image-mobile.png';
import headerImage from 'images/coursera-plus/header-image.png';

const styles = {
  container: () => css`
    background-color: #dbeef6;
    padding: 20px 0;
  `,
};

const desktopStyles = {
  rightSideContainer: () => css`
    display: flex;
    align-items: center;
    height: 100%;
  `,

  dots: () => css`
    position: absolute;
    right: -50px;
    bottom: -30px;

    @media (max-width: ${xlImageBreakpoint}px) {
      bottom: -31px;
      right: -40px;
    }
  `,
};

export const YellowDotsImageDesktop = (props: DesktopImageProps & { sizes: YellowDotsImage }) => {
  const { sizes } = props;
  const { imageWidth, dotsWidth, dotsHeight } = sizes;
  const height = sizes.imageWidth * YELLOW_DOTS_IMAGE_SIZES.heightWidthRatio;
  return (
    <div css={desktopStyles.rightSideContainer}>
      <div style={{ position: 'relative', width: imageWidth, height }}>
        <Imgix src={headerImage} alt={Imgix.DECORATIVE} maxWidth={imageWidth} maxHeight={height} />
        <Imgix src={dots} css={desktopStyles.dots} alt={Imgix.DECORATIVE} maxWidth={dotsWidth} maxHeight={dotsHeight} />
      </div>
    </div>
  );
};

const YellowDots = (props: StaticComponentProps) => {
  const isMobile = props.userAgent?.isMobileBrowser ?? false;
  return (
    <div css={styles.container}>
      <div>
        <Media
          queries={{ xxlImage: `(min-width: ${xlImageBreakpoint}px)`, xlImage: `(min-width: ${mobileBreakpoint}px)` }}
          defaultMatches={{ xxlImage: !isMobile, xlImage: !isMobile }}
        >
          {(matches) => {
            if (matches.xxlImage) {
              return (
                <LegacyDesktop>
                  <YellowDotsImageDesktop sizes={YELLOW_DOTS_IMAGE_SIZES.xxl} />
                </LegacyDesktop>
              );
            } else if (matches.xlImage) {
              return (
                <LegacyDesktop>
                  <YellowDotsImageDesktop sizes={YELLOW_DOTS_IMAGE_SIZES.xl} />
                </LegacyDesktop>
              );
            } else {
              return (
                <LegacyMobile imageUrl={headerImageMobile} defaultRatio={YELLOW_DOTS_IMAGE_SIZES.heightWidthRatio} />
              );
            }
          }}
        </Media>
      </div>
    </div>
  );
};

export default YellowDots;
